import TableRowsIcon from '@mui/icons-material/TableRows';
import { ChartAction } from '../../../hooks/useChartActions';
import { BlueberrySizeTableDialog } from '../components/BlueberrySizeTableDialog';

export const useBlueberrySizeChartActions =
  (): ChartAction<BlueberrySizeChartAction>[] => {
    const actions: ChartAction<BlueberrySizeChartAction>[] = [
      {
        actionId: 'TABLE_VIEW',
        onClick: () => {
          console.debug('table_view');
        },
        Icon: TableRowsIcon,
        ActionDialog: BlueberrySizeTableDialog,
      },
    ];

    return actions;
  };

export type BlueberrySizeChartAction = 'TABLE_VIEW';
